import React, { FC, HTMLAttributes } from 'react';

import { Typography } from '@common/styles';

import { useProductCardContext } from '../../../context/ProductCardContext';
import { Root } from './Price.styled';

/**
 * 상품 가격 컴포넌트
 */
export const Price: FC<React.PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = (props) => {
  const { discount_rate, final_price } = useProductCardContext();
  const isShowDiscountRate = !!discount_rate && discount_rate > 0;

  return (
    <Root {...props}>
      {isShowDiscountRate && <span className={`discount-rate ${Typography.BODY_15_SEMIBOLD}`}>{discount_rate}%</span>}
      <span className={`discount-price ${Typography.BODY_15_SEMIBOLD}`}>{final_price.toLocaleString('ko-KR')}</span>
    </Root>
  );
};
